import HelperUtils from 'utils/Helpers';

function savedInListsText({
    listNames, visibleCount = 3, maxNameLength = 20, savedIn, and
}) {
    if (!listNames || listNames.length === 0) {
        return '';
    }

    const truncatedListNames = listNames.slice(0, visibleCount).map(listName =>
        HelperUtils.truncateGraphemes({
            text: listName.replace(/\n/g, ' '),
            maxTextLength: maxNameLength,
            truncationMarker: '...'
        })
    );

    if (truncatedListNames.length === 1) {
        return `${savedIn} ${truncatedListNames[0]}`;
    }

    if (truncatedListNames.length === 2) {
        return `${savedIn} ${truncatedListNames[0]} ${and} ${truncatedListNames[1]}`;
    }

    if (listNames.length === 3) {
        return `${savedIn} ${truncatedListNames[0]}, ${truncatedListNames[1]}, ${and} ${truncatedListNames[2]}`;
    }

    let result = `${savedIn} ${truncatedListNames.join(', ')}`;

    const remainingCount = listNames.length - truncatedListNames.length;

    if (remainingCount > 0) {
        result += `, ${and} +${remainingCount}`;
    }

    return result;
}

function fromScreamingUpperCaseToCamelCase(text) {
    if (!text) {
        return '';
    }

    return text
        .toLowerCase()
        .split('_')
        .map((part, index) => (index === 0 ? part : part.charAt(0).toUpperCase() + part.slice(1)))
        .join('');
}

function findMatchingSku(currentLovesSkuDetails, targetSkuId, targetProductId) {
    for (let i = 0; i < currentLovesSkuDetails.length; i++) {
        const item = currentLovesSkuDetails[i];

        if (item.sku.skuId === targetSkuId && item.sku.productId === targetProductId) {
            return item;
        }
    }

    return null;
}

function formatCategories(availableCategories) {
    const categoriesFormated = [];

    if (!availableCategories) {
        return categoriesFormated;
    }

    availableCategories.forEach(category => {
        categoriesFormated.push({
            count: category.count,
            categoryId: category.categoryId,
            key: category.categoryName,
            refinementValue: `filters[Category]=${category.categoryName}`,
            refinementValueDisplayName: category.categoryName,
            refinementValueStatus: 1
        });
    });

    return categoriesFormated;
}

function categoriesToApply(availableCategories, selectedCategories) {
    const categoriesStr = [];

    if (!selectedCategories) {
        return categoriesStr;
    }

    selectedCategories.forEach(category => {
        const existentCategory = availableCategories.find(cat => cat.refinementValue === category);

        if (existentCategory) {
            categoriesStr.push(existentCategory.categoryId);
        }
    });

    return categoriesStr;
}

export default {
    savedInListsText,
    fromScreamingUpperCaseToCamelCase,
    findMatchingSku,
    formatCategories,
    categoriesToApply
};
